<ion-content class="content-theme-one">
  <!--top bar-->
  <div class="sectionContainer">

    <div>
      <!-- back button-->
      <ion-icon style="cursor: pointer;" class="iconOpacity" [ngClass]="{'iconResize': homersLayout, 'iconHomersColor': homersLayout }" size="small" slot="start" [ios]="'chevron-back-outline'" [md]="'chevron-back-outline'" (click)="closePopup()"></ion-icon>
    </div>
    <div [ngClass]="{'titleText': homersLayout, 'paytoneFont': homersLayout }">
      <!-- title -->
      {{ news.title.translations[translationService.getLanguage()] }}
    </div>
    
    <div [ngStyle]="{'width': !(this.authservice.isAuthenticated && this.news.canBeDeletedByUser) ? '26px' : 'auto'}">
      @if(this.authservice.isAuthenticated && this.news.canBeDeletedByUser) {
        <!-- delete icon -->
        <ion-icon style="cursor: pointer;" class="iconOpacity" [ngClass]="{'iconResize': homersLayout, 'iconHomersColor': homersLayout }" size="small" slot="start" [ios]="'trash-outline'" [md]="'trash-sharp'" (click)="deletenews()"></ion-icon>
      }
    </div> 
    
    
  </div>

  <!-- main content -->
  <div class="messagesDisplayer">

    <div class="message">
      <div class="message_img">
        <img class="imgs" [src]="getnewsImage()">
      </div>
      <div class="message_content">
        <div class="message_content_title" [ngClass]="{'paytoneFont': homersLayout, 'homersResize': homersLayout}" [innerHtml]="textDisplay(news.title, translationService.getLanguage())">
          <!--{{ news.title.translations[translationService.getLanguage()] }}-->
        </div>

        <div class="message_content_description" [innerHtml]="textDisplay(news.shortDescription, translationService.getLanguage())">
          <!--{{ blog.longDescription.translations[translationService.getLanguage()] }}-->
        </div>

        <div class="message_content_description" [ngClass]="{'poppinsNormalFont': homersLayout, 'homersDescriptionModif': homersLayout}" [innerHtml]="textDisplay(news.longDescription, translationService.getLanguage())">
          <!--{{ news.longDescription.translations[translationService.getLanguage()] }}-->
        </div>

        <!---->
        @if(news.promotionalCode || (news.pricingReference?.showPricing && news.pricingReference?.price)) {
          <div class="Promo_And_Cost_Container">
            
            <div class="Promo_Container" [ngClass]="{'paytoneFont': homersLayout, 'Apply_Font_Weigth': !homersLayout}">
              @if(news.promotionalCode) {
                {{ 'NewsBlog.PromoCode' | translate }} {{ news.promotionalCode }}
              }
            </div>

            <div class="Cost_Container" [ngClass]="{'paytoneFont': homersLayout, 'Apply_Font_Weigth': !homersLayout}">
              @if(news.pricingReference?.showPricing) {
                {{news.pricingReference?.price | currency}}
              }
            </div>
          </div>
        }

        @if(news.btnLink?.translations[translationService.getLanguage()] && news.btnText?.translations[translationService.getLanguage()]) {
          <div class="message_content_options">
            <a class="message_content_options_button" [href]="news.btnLink?.translations[translationService.getLanguage()]">{{ news.btnText?.translations[translationService.getLanguage()] }}</a>
          </div>
        }

        <!---->
        @if((news.noExpiration && news.expirationDate) || this.availableHoursString) {
          <div class="Expiration_And_TimeRange">
            <div class="Expiration">
              @if(news.noExpiration && news.expirationDate) {
                {{'NewsBlog.ExpiresOn' | translate}} {{ formatDate(news.expirationDate) }}
              }
            </div>
            <div class="TimeRange">
              @if(this.availableHoursString){
                {{'NewsBlog.Applicable' | translate}}{{ this.availableHoursString }}
              }
            </div>
          </div>
        }

        <div class="message_content_disclaimer" [ngClass]="{'poppinsNormalFont': homersLayout}" [innerHtml]="textDisplay(news.disclaimer, translationService.getLanguage())">
          <!--{{ news.disclaimer.translations[translationService.getLanguage()] }}-->
        </div>

        @if(news.modalityLink?.translations[translationService.getLanguage()]) {
          <a [href]="news.modalityLink?.translations[translationService.getLanguage()]" class="message_content_modality" [ngClass]="{'poppinsNormalFont': homersLayout}" [innerHtml]="textDisplay(news.modalityLink, translationService.getLanguage())">
            <!--{{ news.modalityLink.translations[translationService.getLanguage()] }}-->
          </a>
        }

        
        
      </div>
    </div>
  </div>

  @if(mobile && settings.configuration.uIoptions?.unDockNavigationBar) {
    <app-undocked-navigation-bar style="z-index: 10;"></app-undocked-navigation-bar>
  }

  <!--
  @if ((mobile && isPopup && !setting.navigationSetting) && setting.configuration.uIoptions) {
    <app-undocked-navigation-bar style="z-index: 10;" [disabledOption]="'Nav.Support'"></app-undocked-navigation-bar>
  }
  -->

</ion-content>
